import React from "react";

import { useTranslation, Trans } from "react-i18next";
import { Link, useNavigate } from "react-router-dom-v5-compat";

import Button, { LinkButton } from "Atoms/Buttons";

import jonny from "../assets/images/welcome_journey/Jonny.png";
import { ContentBlock, InfoPage, SingleColumnPage } from "./Atoms";
import { Form, RadioInput, RadioSelectField } from "./Form";
import { useJourney } from "./sign_up_journeys";
import { Journey, Progress } from "./types";

const PosBossIntroduction = () => {
  const { t } = useTranslation("welcome");
  const {
    saveJourney,
    journey,
    formProps: { handleSubmit, ...formProps },
  } = useJourney();

  const navigate = useNavigate();
  const onSubmit = async (data: Partial<Journey>) => {
    await saveJourney(data);
    navigate("../introductions");
  };

  const submitOnChange = async (data: string) => {
    await saveJourney({ ...journey, venueStatus: data });
    navigate("../introductions");
  };
  const venueStatuses = [
    { value: "first_venue", label: t("formContent.statuses.firstVenue") },
    { value: "seasoned_pro", label: t("formContent.statuses.seasonedPro") },
  ];
  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <div className="mx-auto max-w-xl space-y-64 py-64 text-center">
        <h1 className="text-5xl">{t("landing.welcomeTitle")}</h1>
        <div className="space-y-32">
          <label htmlFor="venueStatus" className="text-2xl text-neutral-600">
            {t("formContent.venueStatus")}
          </label>
          <RadioInput
            onChange={(e) => {
              submitOnChange(e.target.value);
            }}
            name="venueStatus"
            options={venueStatuses}
            formProps={formProps}
          />
        </div>
      </div>
    </Form>
  );
};
export const Landing = ({ progress }: { progress: Progress }) => {
  return (
    <SingleColumnPage progress={progress} content={<PosBossIntroduction />} />
  );
};
